"use client"

import { Eye } from 'lucide-react'
import { useStore } from '@/lib/store'

/**
 * 094 — the accountant's login says what it is on every screen: everything
 * is readable, nothing is editable. The buttons that write are hidden where
 * they live; the database refuses the rest.
 */
export function ReadOnlyBanner() {
  const accountant = useStore((s) => s.userRole === 'accountant')
  if (!accountant) return null
  return (
    <div className="shrink-0 rounded-2xl border border-sky-200 dark:border-sky-500/25 bg-sky-50 dark:bg-sky-500/10 px-4 py-2 flex items-center gap-2.5 text-xs font-bold text-sky-800 dark:text-sky-300">
      <Eye className="size-4 shrink-0" />
      <span className="flex-1 min-w-0">ბუღალტრის ანგარიში — ხედავ ყველაფერს, ცვლილება შეუძლებელია</span>
    </div>
  )
}
